function generateRandomId() {
    const BASE = 36;
    return Math.random()
        .toString(BASE)
        .substr(2, 6);
}

export { generateRandomId };
//# sourceMappingURL=string-utils.js.map
